import React from 'react';
import ReactDOM from 'react-dom/client';
import { ClerkProvider } from '@clerk/clerk-react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './index.css';

// Debug: Log immediately
console.log('[LumiAdmin] main.tsx starting...');

const CLERK_PUBLISHABLE_KEY = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY as string;

console.log('[LumiAdmin] Clerk key:', CLERK_PUBLISHABLE_KEY ? 'Found' : 'MISSING');

if (!CLERK_PUBLISHABLE_KEY) {
  console.error('[LumiAdmin] Missing VITE_CLERK_PUBLISHABLE_KEY');
  document.getElementById('root')!.innerHTML = `
    <div style="display:flex;flex-direction:column;align-items:center;justify-content:center;min-height:100vh;font-family:system-ui;padding:20px;background:#f9fafb;">
      <h1 style="color:#ef4444;margin-bottom:16px;">Configuration Error</h1>
      <p style="color:#6b7280;">Missing Clerk publishable key.</p>
    </div>
  `;
} else {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
        retry: 1,
        staleTime: 5 * 60 * 1000,
      },
    },
  });

  console.log('[LumiAdmin] Rendering React app...');

  try {
    ReactDOM.createRoot(document.getElementById('root')!).render(
      <React.StrictMode>
        <ClerkProvider publishableKey={CLERK_PUBLISHABLE_KEY}>
          <QueryClientProvider client={queryClient}>
            {/* Served at the root of the admin subdomain */}
            <BrowserRouter basename="/">
              <App />
            </BrowserRouter>
          </QueryClientProvider>
        </ClerkProvider>
      </React.StrictMode>
    );
    console.log('[LumiAdmin] React render called');
  } catch (err) {
    console.error('[LumiAdmin] React render error:', err);
    document.getElementById('root')!.innerHTML = `
      <div style="display:flex;flex-direction:column;align-items:center;justify-content:center;min-height:100vh;font-family:system-ui;padding:20px;background:#f9fafb;">
        <h1 style="color:#ef4444;margin-bottom:16px;">Render Error</h1>
        <p style="color:#6b7280;">${err}</p>
      </div>
    `;
  }
}
